import { Chip } from '@mui/material';
import { CompanyUserStatus } from '@utils/enums.ts';

interface CompanyUserStatusTagProps {
  status: string;
}

/**
 * @param props - The props for the component.
 * @returns A React component that displays a status tag using MUI Chip.
 */
function CompanyUserStatusTag({ status }: CompanyUserStatusTagProps) {
  const getColor = (currentStatus: string) => {
    switch (currentStatus) {
      case CompanyUserStatus.Active:
        return 'success';
      case CompanyUserStatus.Inactive:
      case CompanyUserStatus.InvitationExpired:
        return 'default';
      case CompanyUserStatus.InvitationPending:
      case CompanyUserStatus.AccountPendingApproval:
        return 'warning';
      default:
        return 'default';
    }
  };

  if (!status) {
    return null;
  }

  return (
    <Chip
      label={status}
      color={getColor(status)}
      variant="outlined"
      sx={{
        fontWeight: 500,
        textTransform: 'capitalize',
        borderRadius: '8px',
        px: 1.5,
        py: 0.5,
        fontSize: '0.875rem',
      }}
    />
  );
}

export default CompanyUserStatusTag;
